import { render } from "./ThankYouPage.vue?vue&type=template&id=19bce3ce&scoped=true&ts=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=ts"
export * from "./ThankYouPage.vue?vue&type=script&lang=ts"

import "./ThankYouPage.vue?vue&type=style&index=0&id=19bce3ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bce3ce"]])

export default __exports__